import { axiosV1 } from 'interceptors/axios';
import { ApiQueryParams, Encumbrance } from 'types';

import { decryptResponse } from 'utils/token';

type GetPartnerEncumbrancesProps = {
  partnerId: string;
  signal?: AbortSignal;
  params?: ApiQueryParams;
};

type GetPartnerEncumbrancesResponse = {
  data: Encumbrance[];
  total: number;
};

export const getPartnerEncumbrances = async ({
  partnerId,
  params,
  signal, // eslint-disable-line
}: GetPartnerEncumbrancesProps) => {
  const { data } = await axiosV1.get(`/encumbrances/partner`, {
    params: {
      partnerId,
      ...params,
    },
  });

  const decodedData = (await decryptResponse(
    data
  )) as GetPartnerEncumbrancesResponse;
  return decodedData;
};
